import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import { ApiResponseCode, BroadCastChannelMessageTypeConstant, SHARED_IMPORTS } from '@boshared';
import { Capacitor } from '@capacitor/core';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { UserApiService } from 'projects/bo/src/app/core/services/api/user/user-api.service';
import { EditProfileRequest, UserDto } from 'projects/bo/src/app/core/services/api/user/user.model';
import { BaseFormComponent } from 'projects/bo/src/app/shared/abstracts/base-form-component.abstract';
import { DynamicFormModule } from 'projects/bo/src/app/shared/components/dynamic-form/dynamic-form.module';
import { AlphaNumericPattern } from 'projects/bo/src/app/shared/constants/regex.const';
import { GlobalService } from 'projects/bo/src/app/shared/services/global-data/global.service';
import { take } from 'rxjs';
import { BROADCAST_SERVICE_TOKEN } from '../../../core/services/helpers/broadcast.service';
import { AccountState } from '../../../core/services/states/account.service';
import { TopnavComponent } from '../../../layout/topnav/topnav/topnav.component';
import { ChangePasswordComponent } from './component/change-password/change-password.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.less'],
  imports: [...SHARED_IMPORTS, DynamicFormModule, ChangePasswordComponent, TopnavComponent]
})
export class ProfileComponent extends BaseFormComponent implements OnInit {
  protected destroyRef = inject(DestroyRef);
  protected globalService = inject(GlobalService);
  protected broadcastService = inject(BROADCAST_SERVICE_TOKEN);
  protected accountState = inject(AccountState);
  protected userApi = inject(UserApiService);
  protected editData: UserDto = this.resolverData['editData'];
  protected form = this.fb.group({
    userName: this.fb.control<string | null>(null, [
      Validators.required,
      Validators.pattern(AlphaNumericPattern),
      Validators.maxLength(20)
    ]),
    createDate: this.fb.control<string | null>({ value: null, disabled: true })
  });
  protected selectedTab = 0;
  constructor() {
    super();
    addIcons({
      arrowBackOutline
    });
  }
  ngOnInit() {
    this.form.patchValue({
      userName: this.editData.name,
      createDate: new Date(this.editData.createDate).toLocaleString()
    });

    this.form.markAsPristine();
  }
  private updateAccountInfoState(username: string) {
    const existingAccount = this.accountState.get();
    if (existingAccount) {
      existingAccount.userName = username;
      this.accountState.setState(existingAccount);
    }
    this.broadcastService.publish({
      type: BroadCastChannelMessageTypeConstant.AccountInfo,
      payload: {}
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    const formData = this.form.getRawValue();
    const model = {
      accountName: formData.userName
    } as EditProfileRequest;

    this.userApi
      .EditProfile(model)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        if (res?.code == ApiResponseCode.Success) {
          if (this.globalService.isMobileStyle) {
            this.noticeSvc.showSuccess(`common.message.codeMessage.${res.code}`, '', () => {
              this.updateAccountInfoState(formData.userName ?? '');

              if (Capacitor.isNativePlatform()) {
                this.navigateBack();
                return;
              }

              this.router.navigate(['/accountMobile']);
            });
          } else {
            this.noticeSvc.showSuccess(`common.message.codeMessage.${res.code}`, '', () => {
              this.updateAccountInfoState(formData.userName ?? '');
            });
          }
        }
      });
  }
}
